module.exports = __webpack_public_path__ + "img/small_eye_chart01.df3b631d.jpg";